import LabeledActionButton from './LabeledActionButton';

export default LabeledActionButton;



// WEBPACK FOOTER //
// ./src/ondemand/components/LabeledActionButton/index.js